import React from "react";

const URL_PATTERN = /(https?:\/\/[^\s<>"']+)/g;

export const Linkify: React.FC<{ children: string; className?: string }> = ({ children, className }) => {
  const parts = children.split(URL_PATTERN);

  return (
    <>
      {parts.map((part, i) =>
        /^https?:\/\//.test(part) ? (
          <a key={i} href={part} target="_blank" rel="noopener noreferrer" className={className}>
            {part}
          </a>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </>
  );
};
